import React, {Component} from 'react';
import {connect} from 'react-redux';
import LoginForm from '../components/loginForm'
import {
    requestToLogin,
    changeUserAtLoginProperties, displayInfoDialogBox, displayRejectAuthDialogBox, changeUserStateSettings
} from "../actions/user";
import {
	changeNewSolicitorProperties, solicitorFormEmailInfo, solicitorFormEmailValidationError, solicitorFormUsernameInfo,
	solicitorFormUsernameValidationError
} from "../actions/newSolicitor";
import 'airbnb-js-shims';

//Higher order component for user authentication handling
const Authentication = (allowedRoles) =>
	(WrappedComponent) => {
		class WithAuthorization extends Component {
			validateEmail(email) {
				var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				return re.test(email);
			}

			//function called when login button is entered
			HandleUserLoginFormSubmit = (evt) => {
				evt.preventDefault();

				if(this.props.user.madeAttempts >= 3 && (!this.props.user.reCaptchaResponse || this.props.user.reCaptchaResponse.trim().length === 0)){
                    this.props.changeUserStateSettings('reCaptchaMessage',
                        'ReCaptcha validation has failed.');
                    return false;
				}

				// if(this.validateEmail(this.props.user.loginFormData.username)){
				// 	this.props.logIn({email:this.props.user.loginFormData.email,password:this.props.user.loginFormData.password});
				// }else {
					this.props.logIn(this.props.user.loginFormData);
				// }
			};

            verifyCallback = (response) =>
			{
                this.props.changeUserStateSettings('reCaptchaMessage', '');
				this.props.changeUserStateSettings('reCaptchaResponse', response)
			};

            callback = () => {
                console.log('Done !!');
            };



            render() {
				let role = this.props.user.loggedInUser.roles[0];
				//check if  user is logged in . if yes, then the wrapped component is rendered
				//else the login component appears
				if (allowedRoles.includes(role)) {
					return <WrappedComponent user={this.props.user}/>
				} else {
					return <LoginForm
							history={this.props.history}
							changeUserStateSettings={this.props.changeUserStateSettings}
							callback={this.callback}
							verifyCallback={this.verifyCallback}
							User={this.props.user}
							HandleNewSolicitor={this.props.newSolicitorProperties}
							DisplaySolicitorFormUsernameValidationError={this.props.displaySolicitorFormUsernameValidationError}
							DisplaySolicitorFormEmailValidationError={this.props.displaySolicitorFormEmailValidationError}
							DisplaySolicitorFormUsernameInfo={this.props.displaySolicitorFormUsernameInfo}
							DisplaySolicitorFormEmailInfo={this.props.displaySolicitorFormEmailInfo}
							DisplayAuthBox={this.HandleUserLoginFormSubmit}
							DisplayDialogBox={this.props.displayDialogBox}
							HandleInputChange={this.props.userLoginProperties}
						/>
				}
			}
		}
		const mapStateToProps = (state) => {
			return {
				user: state.user
			}
		};

		const mapDispatchToProps = (dispatch) => {
			return {
				userLoginProperties: (userProp, value) => {
					dispatch(changeUserAtLoginProperties(userProp, value))
				},
				displayDialogBox: () => {
					dispatch(displayInfoDialogBox())
				},
				displayAuthDialogBox: () => {
					dispatch(displayRejectAuthDialogBox())
				},
				displaySolicitorFormEmailInfo: () => {
					dispatch(solicitorFormEmailInfo())
				},
				displaySolicitorFormUsernameInfo: () => {
					dispatch(solicitorFormUsernameInfo())
				},
				displaySolicitorFormEmailValidationError: () => {
					dispatch(solicitorFormEmailValidationError())
				},
				displaySolicitorFormUsernameValidationError: () => {
					dispatch(solicitorFormUsernameValidationError())
				},
				newSolicitorProperties: (property, value) => {
					dispatch(changeNewSolicitorProperties(property, value))
				},
				logIn: (user) => {
					dispatch(requestToLogin(user))
				},
                changeUserStateSettings: (key, value) => {
					dispatch(changeUserStateSettings(key, value))
				}
			}
		};

		return connect(mapStateToProps, mapDispatchToProps)(WithAuthorization);
	};


export default Authentication